(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merovi-discount-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const root = event.target.closest('[data-merovi-discount]');
    if (!root) return;

    const dialog = root.querySelector('[data-merovi-dialog]');

    if (event.target.closest('[data-merovi-open]')) dialog.showModal();
    if (event.target.closest('[data-merovi-close]')) dialog.close();
    if (event.target.closest('[data-merovi-dismiss]')) {
      root.querySelector('[data-merovi-teaser]').hidden = true;
      try {
        localStorage.setItem('merovi-discount-dismissed-until', String(Date.now() + 14 * 24 * 60 * 60 * 1000));
      } catch (error) {
        // The teaser still closes when browser storage is unavailable.
      }
    }

    const copyButton = event.target.closest('[data-merovi-copy]');
    if (copyButton) {
      navigator.clipboard.writeText(copyButton.dataset.code)
        .then(() => {
          root.querySelector('[data-merovi-copied]').hidden = false;
        })
        .catch(() => {});
    }
  });

  document.querySelectorAll('[data-merovi-discount]').forEach((root) => {
    try {
      if (Number(localStorage.getItem('merovi-discount-dismissed-until')) > Date.now()) {
        root.querySelector('[data-merovi-teaser]').hidden = true;
      }
    } catch (error) {
      // Keep the teaser visible when browser storage is unavailable.
    }
    if (root.querySelector('[data-merovi-success]')) {
      root.querySelector('[data-merovi-dialog]').showModal();
      try {
        localStorage.setItem('merovi-discount-dismissed-until', String(Date.now() + 14 * 24 * 60 * 60 * 1000));
      } catch (error) {
        // The success dialog can still open without browser storage.
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merovi-moment-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.merovi-moment-hero';
    const instances = new WeakMap();

    const hexToRgb = (hex) => {
      const value = hex.replace('#', '');
      const normalized = value.length === 3 ? value.split('').map((character) => character + character).join('') : value;
      const number = Number.parseInt(normalized, 16);
      return {
        r: (number >> 16) & 255,
        g: (number >> 8) & 255,
        b: number & 255
      };
    };

    const initMeroviMomentHero = (root) => {
      if (!root || instances.has(root)) return;

      const visual = root.querySelector('.merovi-moment-hero__visual');
      const canvas = root.querySelector('.merovi-moment-hero__canvas');
      const rings = root.querySelector('.merovi-moment-hero__rings');
      if (!visual || !canvas || !rings) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const showParticles = root.dataset.showParticles === 'true';
      const intensityMap = { low: 0.55, medium: 1, high: 1.35 };
      const intensity = intensityMap[root.dataset.motionIntensity] || 1;
      const accent = hexToRgb(root.dataset.accentColor || '#b85f36');
      const context = canvas.getContext('2d', { alpha: true });
      let width = 0;
      let height = 0;
      let frame = 0;
      let visible = false;
      let dragging = false;
      let pointerStartX = 0;
      let dragRotation = 0;
      let targetX = -8;
      let targetY = 12;
      let currentX = -8;
      let currentY = 12;
      let particles = [];

      const particleCount = () => window.matchMedia('(max-width: 749px)').matches ? 14 : 34;

      const makeParticles = () => Array.from({ length: particleCount() }, () => ({
        x: Math.random(),
        y: Math.random(),
        radius: 0.8 + Math.random() * 2.8,
        alpha: 0.08 + Math.random() * 0.2,
        speed: 0.00008 + Math.random() * 0.00018,
        phase: Math.random() * Math.PI * 2
      }));

      const resize = () => {
        const bounds = visual.getBoundingClientRect();
        const ratio = Math.min(window.devicePixelRatio || 1, 1.75);
        width = Math.max(1, bounds.width);
        height = Math.max(1, bounds.height);
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        particles = makeParticles();
      };

      const drawParticles = (time) => {
        context.clearRect(0, 0, width, height);
        if (!showParticles) return;
        particles.forEach((particle) => {
          const drift = Math.sin(time * particle.speed + particle.phase);
          const x = (particle.x * width) + drift * 20;
          const y = (particle.y * height) - ((time * particle.speed * 18) % (height + 40));
          const wrappedY = ((y % (height + 40)) + (height + 40)) % (height + 40) - 20;
          context.beginPath();
          context.fillStyle = `rgba(${accent.r}, ${accent.g}, ${accent.b}, ${particle.alpha})`;
          context.arc(x, wrappedY, particle.radius, 0, Math.PI * 2);
          context.fill();
        });
      };

      const render = (time) => {
        if (!visible || document.hidden) {
          frame = 0;
          return;
        }
        currentX += (targetX - currentX) * 0.055;
        currentY += ((targetY + dragRotation) - currentY) * 0.055;
        root.style.setProperty('--rx', `${currentX}deg`);
        root.style.setProperty('--ry', `${currentY}deg`);
        drawParticles(time);
        frame = window.requestAnimationFrame(render);
      };

      const start = () => {
        if (reducedMotion || frame || !visible || document.hidden) return;
        frame = window.requestAnimationFrame(render);
      };

      const stop = () => {
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
      };

      const onPointerMove = (event) => {
        if (event.pointerType === 'touch') return;
        const bounds = visual.getBoundingClientRect();
        const normalizedX = ((event.clientX - bounds.left) / bounds.width) - 0.5;
        const normalizedY = ((event.clientY - bounds.top) / bounds.height) - 0.5;
        targetX = -8 - normalizedY * 16 * intensity;
        targetY = 12 + normalizedX * 22 * intensity;
        if (dragging) dragRotation += (event.clientX - pointerStartX) * 0.08 * intensity;
        pointerStartX = event.clientX;
      };

      const onPointerDown = (event) => {
        if (event.pointerType === 'touch') return;
        dragging = true;
        pointerStartX = event.clientX;
        visual.setPointerCapture(event.pointerId);
      };

      const onPointerUp = (event) => {
        dragging = false;
        if (visual.hasPointerCapture(event.pointerId)) visual.releasePointerCapture(event.pointerId);
      };

      const onPointerLeave = () => {
        if (dragging) return;
        targetX = -8;
        targetY = 12;
      };

      const onVisibilityChange = () => document.hidden ? stop() : start();
      const resizeObserver = new ResizeObserver(resize);
      const intersectionObserver = new IntersectionObserver((entries) => {
        visible = entries[0]?.isIntersecting === true;
        if (visible) start(); else stop();
      }, { threshold: 0.08 });

      resizeObserver.observe(visual);
      intersectionObserver.observe(root);
      visual.addEventListener('pointermove', onPointerMove, { passive: true });
      visual.addEventListener('pointerdown', onPointerDown, { passive: true });
      visual.addEventListener('pointerup', onPointerUp, { passive: true });
      visual.addEventListener('pointercancel', onPointerUp, { passive: true });
      visual.addEventListener('pointerleave', onPointerLeave, { passive: true });
      document.addEventListener('visibilitychange', onVisibilityChange);
      resize();

      const destroy = () => {
        stop();
        resizeObserver.disconnect();
        intersectionObserver.disconnect();
        visual.removeEventListener('pointermove', onPointerMove);
        visual.removeEventListener('pointerdown', onPointerDown);
        visual.removeEventListener('pointerup', onPointerUp);
        visual.removeEventListener('pointercancel', onPointerUp);
        visual.removeEventListener('pointerleave', onPointerLeave);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        context.clearRect(0, 0, width, height);
        instances.delete(root);
      };

      instances.set(root, { destroy });
    };

    const destroyMeroviMomentHero = (root) => instances.get(root)?.destroy();
    const initializeAll = (scope = document) => scope.querySelectorAll(selector).forEach(initMeroviMomentHero);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      destroyMeroviMomentHero(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
